/* eslint-disable max-lines */
//
//  SDKDataCoreAIRequests.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//  Copyright © 2025 Supernova. All rights reserved.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { AIGetRouteQueryTask, RelaySummarizeStrategy, } from "../../areas/SDKAreaRelay";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Request engine: AI
export class DataCoreAIRequests {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(bridge) {
        this.cachedEndpoints = new Map();
        this.bridge = bridge;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Agents
    /* Remote: Invokes Amy, the AI assistant, to answer questions or chat about product-development topics. */
    async invokeAmy(workspaceId, designSystemId, versionId, prompt, chatId, systemPrompt) {
        const endpoint = await this.getCachedAIEndpoint(AIGetRouteQueryTask.amy);
        const payload = {
            prompt,
            meta: {
                chatId,
                system: systemPrompt,
                context: {
                    workspaceId,
                    designSystemId,
                    versionId,
                },
            },
        };
        const result = await this.bridge.postStreamed(endpoint, payload);
        return result;
    }
    /** Invokes an AI agent to answer questions or perform tasks based on the provided prompt */
    async invokeAgent(agent, prompt, projectId, branchId) {
        const endpoint = await this.getCachedAIEndpoint(AIGetRouteQueryTask.agent);
        const result = await this.bridge.postStreamed(endpoint, {
            agent,
            prompt,
            meta: {
                projectId,
                branchId: branchId !== null && branchId !== void 0 ? branchId : undefined,
            },
        });
        return result;
    }
    /** Summarizes text using AI */
    async summarizeText(text, options) {
        var _a, _b;
        const endpoint = this.bridge.getAIEndpoint(`internal/summarize`);
        const result = await this.bridge.post(endpoint, {
            text,
            options: {
                maxWords: (_a = options === null || options === void 0 ? void 0 : options.maxWords) !== null && _a !== void 0 ? _a : 5,
                strategy: (_b = options === null || options === void 0 ? void 0 : options.strategy) !== null && _b !== void 0 ? _b : RelaySummarizeStrategy.noun,
            },
        });
        return result;
    }
    /** Retrieves executable url for various AI tasks */
    async executableTaskUrl(task) {
        const endpoint = this.bridge.getAIEndpoint(`internal/get-request-url`);
        const result = await this.bridge.post(endpoint, {
            task,
        });
        return result === null || result === void 0 ? void 0 : result.routeUrl;
    }
    async getCachedAIEndpoint(task) {
        const taskUrl = this.cachedEndpoints.get(task);
        if (taskUrl) {
            return taskUrl;
        }
        const url = await this.executableTaskUrl(task);
        this.cachedEndpoints.set(task, url);
        return url;
    }
}
